import React, { useState } from 'react';
import { FiChevronDown, FiStar, FiFileText } from 'react-icons/fi';
import { Dropdown } from '@/components/custom/dropdown/dropdown';
import moment from 'moment';
import 'moment/locale/pt';
import { confirm } from '@/lib/confirm';
import { Link } from 'react-router-dom';
import { useSurvey } from '@/hooks/useSurvey';
import usePermission from '@/hooks/usePermission';
import { SurveyForm } from './SurveyForm';
import { Modal } from '@/components/custom/modal/modal';
import { useTranslation } from 'react-i18next';
import { DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';

export default function QuizCard(props) {
  const { t } = useTranslation();
  const { survey, onDelete, relationshipsLoading, relationships } = props;
  const [activeSurvey, setActiveSurvey] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { setCurrentSurvey } = useSurvey();

  const quizStatusClass = status => {
    switch (status) {
      case 'Inativo':
        return 'badge--danger';
      case 'Ativo':
        return 'badge--success';
    }
  };

  const handleDelete = async () => {
    const confirmed = await confirm({
      title: t('projects.warningDeleteQuest'),
      description: t('projects.warningDeleteCannotBeUndoneText'),
      confirmText: t('button.yes'),
      cancelText: t('button.no')
    });
    if (confirmed) {
      onDelete();
    }
  };

  return (
    <div className="card">
      <div className="card__container">
        <span className="card__icon-wrapper card__icon-wrapper--sm">
          <FiStar className="card__icon card__icon--md" />
        </span>

        <div className="card__content">
          <header className="card__header">
            <div className="card__inner-header">
              <h3
                className="card__title"
                title={survey.title}
              >
                {survey.title}
              </h3>
            </div>

            <span className={`badge badge--success badge--tiny ${quizStatusClass(survey.about.status)}`}>{survey.about.status}</span>
          </header>

          <div className="card__body">
            <div className="card__columns">
              <p
                className="card__count"
                title={`${survey.about['questions-count']} ${t('nps.questions')}`}
              >
                {survey.representation === 'stars' ? <FiStar className="card__icon" /> : <FiFileText className="card__icon" />} {survey.about['questions-count']}
              </p>
              <p className="card__info">
                <span>{t('textsCommon.availableUntil')}: </span>
                {moment(survey['finished-at']).format(t('datesForm.formatDate'))}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card__footer">
        <ButtonGroup className="w-full">
          {survey.representation === 'stars' && (
            <Link
              to={`/questionario/criar/estrela/${survey.id}`}
              type="button"
              className="btn btn--outline btn--small"
              onClick={() => {
                setCurrentSurvey(survey);
              }}
            >
              {t('nps.accessQuest')}
            </Link>
          )}
          {survey.representation === 'text' && (
            <Link
              to={`/questionario/criar/aberto/${survey.id}`}
              type="button"
              className="btn btn--outline btn--small"
              onClick={() => {
                setCurrentSurvey(survey);
              }}
            >
              {t('nps.accessQuest')}
            </Link>
          )}

          {usePermission('Excluir questionários', 'Questionário de Percepção') || usePermission('Editar questionários', 'Questionário de Percepção') ? (
            <Dropdown className="btn--small btn btn--outline">
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                >
                  <FiChevronDown size={20} />
                </Button>
              </DropdownMenuTrigger>

              <Dropdown.Content>
                {usePermission('Excluir questionários', 'Questionário de Percepção') && (
                  <Dropdown.Item
                    onClick={() => {
                      handleDelete();
                    }}
                  >
                    {t('button.delete')}
                  </Dropdown.Item>
                )}
                {usePermission('Editar questionários', 'Questionário de Percepção') && (
                  <Dropdown.Item
                    onClick={() => {
                      setShowModal(true);
                      setActiveSurvey(survey);
                    }}
                  >
                    {t('button.edit')}
                  </Dropdown.Item>
                )}

                {survey.representation === 'stars' && <Dropdown.Item to={`/questionario/estrela/${survey.id}`}>{t('button.viewData')}</Dropdown.Item>}
                {survey.representation === 'text' && <Dropdown.Item to={`/questionario/aberto/${survey.id}`}>Ver respostas</Dropdown.Item>}
              </Dropdown.Content>
            </Dropdown>
          ) : null}
        </ButtonGroup>
      </div>
      <Modal
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setActiveSurvey(null);
        }}
      >
        <SurveyForm
          relationshipsLoading={relationshipsLoading}
          relationships={relationships}
          activeSurvey={activeSurvey}
          onClose={() => {
            setShowModal(false);
            setActiveSurvey(null);
          }}
        />
      </Modal>
    </div>
  );
}
